<template>
    <el-dialog
        v-loading.fullscreen.lock="loading"
        :visible.sync="mapTrackVisible"
        :show-close="false"
        center
        width="620px"
        :before-close="handleClose">
        <div class="mapTrack">
            <div class="mapTrack_title">物流跟踪</div>
            <div id="mapContainer"></div>
            <div class="mapTrack_list">
                <div v-for="(item,index) in addressData.logistics_speed" :key="index">
                    <div class="mapTrack_list_header">
                        <img v-if="index == 0" class="mapTrack_list_header_img" src="../../../assets/order/map_point.png" alt="">
                        <img v-else class="mapTrack_list_header_img" src="../../../assets/order/map_point_no.png" alt="">
                        <div class="mapTrack_list_header_time">2020.7.20 18:29</div>
                    </div>
                    <div class="mapTrack_list_footer">
                        <div class="mapTrack_list_footer_line"></div>
                        <div class="mapTrack_list_footer_content" :class="{'mapTrack_list_footer_content_select' : index == 0}">{{item.content}}</div>
                    </div>
                </div>
            </div>
            <div class="mapTrack_action">
                <el-button type="primary" @click="handleClose">确定</el-button>
            </div>
            
        </div>
        

    </el-dialog>
   
</template>

<script>
import AMap from 'AMap'
export default {
    props:["mapTrackVisible","addressData"],
   data (){
       return {
           value:'',
           imgList:[],
           selectIconIndex:'',
           loading:false
       }
   },
   components: {

   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       handleClose(){
           console.log(12345);
            this.$emit("update:mapTrackVisible",false)   
       },
       parseRouteToPath(route) {
            var path = []

            for (var i = 0, l = route.steps.length; i < l; i++) {
                var step = route.steps[i]

                for (var j = 0, n = step.path.length; j < n; j++) {
                path.push(step.path[j])
                }
            }

            return path
        },
        drawRoute (route,map) {
            var path = this.parseRouteToPath(route)
            var routeLine = new AMap.Polyline({
                path: path,
                isOutline: true,
                outlineColor:'#2D579B',
                borderWeight: 1,
                strokeWeight: 3,
                strokeColor: '#2D579B',
                lineJoin: 'round'
            })

            routeLine.setMap(map)

            // 调整视野达到最佳显示区域
            map.setFitView([ routeLine ])
        },
       mapInit(){
           let data = this.addressData;
           let _this = this;
           let center = [];
           var map;
           if(data.drive_longitude && data.drive_latitude){
               map = new AMap.Map("mapContainer", {
                    resizeEnable: true,
                    center: [parseFloat(data.drive_longitude), parseFloat(data.drive_latitude)],//地图中心点
                    
                });
           }else{
               map = new AMap.Map("mapContainer", {
                    resizeEnable: true
                    
                });
           }
            //构造路线导航类
            var driving = new AMap.Driving({
                map: map,
                showTraffic:false,
                isOutline:false
            }); 
            // 根据起终点经纬度规划驾车导航路线
            if(data.drive_longitude && data.drive_latitude){
                    driving.search(new AMap.LngLat(parseFloat(data.start_longitude), parseFloat(data.start_latitude)), new AMap.LngLat(parseFloat(data.end_longitude), parseFloat(data.end_latitude)),{
                    waypoints:[new AMap.LngLat(parseFloat(data.drive_longitude), parseFloat(data.drive_latitude))]
                }, function(status, result) {
                    // console.log(result);
                    // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
                    if (status === 'complete') {
                        // log.success('绘制驾车路线完成')
                        if (result.routes && result.routes.length) {
                            // 绘制第一条路线，也可以按需求绘制其它几条路线
                            _this.drawRoute(result.routes[0],map)
                        }
                    } else {
                        // log.error('获取驾车数据失败：' + result)
                    }
                });
            }else{
                driving.search(new AMap.LngLat(parseFloat(data.start_longitude), parseFloat(data.start_latitude)), new AMap.LngLat(parseFloat(data.end_longitude), parseFloat(data.end_latitude)),{
                    
                }, function(status, result) {
                    // console.log(result);
                    // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
                    if (status === 'complete') {
                        // log.success('绘制驾车路线完成')
                        if (result.routes && result.routes.length) {
                            // 绘制第一条路线，也可以按需求绘制其它几条路线
                            _this.drawRoute(result.routes[0],map)
                        }
                    } else {
                        // log.error('获取驾车数据失败：' + result)
                    }
                });
            }
            
            //  var driving2 = new AMap.Driving({
            //     map: map,
            //     showTraffic:false,
            //     isOutline:false
            // }); 
            // driving.search( new AMap.LngLat(parseFloat(data.drive_longitude), parseFloat(data.drive_latitude)),new AMap.LngLat(parseFloat(data.end_longitude), parseFloat(data.end_latitude)),{
            //     // waypoints:[new AMap.LngLat(parseFloat(data.drive_longitude), parseFloat(data.drive_latitude))]
            // }, function(status, result) {
            //     // console.log(result);
            //     // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
            //     if (status === 'complete') {
            //         // log.success('绘制驾车路线完成')
            //         if (result.routes && result.routes.length) {
            //             // 绘制第一条路线，也可以按需求绘制其它几条路线
            //             _this.drawRoute(result.routes[0],map,'')
            //         }
            //     } else {
            //         // log.error('获取驾车数据失败：' + result)
            //     }
            // });
       }
   },
   created() {
       
   },
   mounted() {
       this.$nextTick(() => {
           this.mapInit();
       });
       
   }
}
</script>

<style scoped lang='less'>
.mapTrack{
    &_list{
        &_header{
            margin-top:16px;
            padding-left:120px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            &_img{
                width:19px;
                height: 19px;
            }
            &_time{
                color:#999999;
                margin-left: 12px;
                font-size: 14px;
            }
        }
        &_footer{
            padding-left:120px;
            font-size: 14px;
            color:#999;
            display: flex;
            &_line{
                width:1px;
                height: 30px;
                border-left: 1px dashed #E1E1E1;
                position: relative;
                left: 9px;
                top:2px;
            }
            &_content{
                line-height: 20px;
                margin-top:6px;
                margin-left:30px;
            }
            &_content.mapTrack_list_footer_content_select{
                font-size: 16px;
                color:#333;
            }
        }
    }
    #mapContainer{
        width:580px;
        height: 267px;
    }
    #panel{
        width:0;
        height: 0;
        overflow: hidden;
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        text-align: center;
        margin-bottom:20px;
    }
    /deep/ .amap-lib-marker-from,/deep/ .amap-lib-marker-to{

        width:37px;
        height: 40px;
        left: -10px;
    }
    /deep/ .amap-lib-marker-mid{
        width:22px;
        height: 17px;
    }
    /deep/ .amap-lib-marker-from{
        background:url('../../../assets/order/map_start.png') no-repeat;
        background-size: cover;
    }
    /deep/ .amap-lib-marker-mid{
        background:url('../../../assets/order/map_car.png') no-repeat;
        background-size: cover;
    }
     /deep/ .amap-lib-marker-to{
        background:url('../../../assets/order/map_end.png') no-repeat;
        background-size: cover;
    }
    &_action{
        text-align: center;
        margin-top:20px;
        /deep/ .el-button{
            width:104px;
            font-size: 16px;
            font-weight: normal;
            padding: 11px 19px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails/components/mapTrack.vue